"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyContactMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const company_entity_1 = require("./company.entity");
const contact_entity_1 = require("./contact.entity");
let CompanyContactMap = class CompanyContactMap {
    constructor(contactId, companyId) {
        this.contactId = contactId;
        this.companyId = companyId;
    }
};
exports.CompanyContactMap = CompanyContactMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Object)
], CompanyContactMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "contact_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], CompanyContactMap.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], CompanyContactMap.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => company_entity_1.Company, (company) => company.companyContactMaps, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "company_id" }),
    tslib_1.__metadata("design:type", Object)
], CompanyContactMap.prototype, "company", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_entity_1.Contact, (contact) => contact.companyContactMaps, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Object)
], CompanyContactMap.prototype, "contact", void 0);
exports.CompanyContactMap = CompanyContactMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("company_contact_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number])
], CompanyContactMap);
